(ns ncr.widgets.inline-edit
  (:require
   [goog.events.EventType :as EventType]
   [goog.events.KeyCodes :as KeyCodes]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]
   [ncr.widgets.datev]))

(defn c-inline-edit__input [{:keys [value on-change on-commit on-cancel hint]}]
  (let [ref (uix/ref)]
    (uix/with-effect [@ref]
      (when-let [el @ref] (.focus el)))

    (w/use-event ref EventType/KEYDOWN
      (fn [e]
        (when (= (.-target e) (.-currentTarget e))
          (condp = (.-keyCode e)
            KeyCodes/ENTER
            (on-commit value)
            KeyCodes/ESC
            (if (seq value)
              (on-change "")
              (on-cancel))
            nil))))

    [pf/l-flex
     {:direction :column :class-name :ncr-c-inline-edit :on-click (u/isolate* nil)}
     [pf/c-input-group
      {:class [:pf-u-mb-0 :ncr-c-inline-edit__input]}
      [pf/c-text-input
       {:value value
        :ref ref
        :on-change on-change}]
      [:div
       {:class [:pf-m-action-group :pf-m-icon-group]}
       [pf/c-button
        {:variant :plain :class [:pf-m-valid :pf-u-active-color-100]
         :on-click (u/isolate* on-commit)}
        [pf/c-check-icon]]
       [pf/c-button
        {:variant :plain :on-click (u/isolate* on-cancel)}
        [pf/c-times-icon]]]]
     (when-not (empty? hint)
       [pf/c-truncate
        {:content
         [:small.pf-u-link-color {:class :ncr-c-inline-edit__hint} hint]
         :on-click
         (u/isolate*
           #(on-change hint))}])]))

(defn- c-inline-edit__text [{:keys [on-click value on-start-edit read-only?]}]
  [pf/c-split {:class-name "ncr-c-inline-edit"}
   [pf/c-split-item
    [pf/c-truncate
     {:class-name "ncr-c-inline-edit__truncate"
      :position :middle
      :on-click (u/isolate* on-click)
      :content value}]]
   [pf/c-split-item {:class-name "ncr-c-inline-edit__icon"}
    (when-not read-only?
      [w/c-mdi-icon
       {:icon :pencil
        :on-click
        (u/isolate* on-start-edit)}])]])

(defn c-inline-edit [{:keys [on-click value on-edit-commit read-only? on-pre-edit] :as props}]
  (let [edit (uix/state nil)]
    (if (some? @edit)
      [c-inline-edit__input
       {:value (:value @edit)
        :hint (:hint props)
        :on-change (fn [v _] (swap! edit assoc :value v))
        :on-commit
        (fn []
          (let [{:keys [value save]} @edit]
            (when (and on-edit-commit (on-edit-commit value save))
              (reset! edit nil))))
        :on-cancel
        #(reset! edit nil)}]
      [c-inline-edit__text
       {:value value
        :read-only? read-only?
        :on-click on-click
        :on-start-edit
        (fn []
          (let [[value save] (if on-pre-edit (on-pre-edit value) [value nil])]
            (reset! edit {:value value :save save})))}])))
